import { BasePageProps } from '../BasePage'
import { PageWithBuildingState, buildingInitialState } from '../PageWithBuilding'

import { store } from '../../redux/store'

import { createReducer, createAction } from '@reduxjs/toolkit'

export interface HomePageProps extends BasePageProps {}

/* indicazioni per il refactor : https://app.clickup.com/t/86bwjrc9r */
type HomeState = {
    materiale: string | undefined
    altri_materiali: string | undefined
    stato_abitazione: string | undefined
    
    abitazione_principale: boolean | undefined
    sede_lavoro: boolean | undefined
    vincolato_belle_arti: boolean | undefined
    
    assicurazione_incendio: boolean | undefined
    assicurazione_furto: boolean | undefined
    valore_beni: number | undefined

    materialeError: string | undefined
    altri_materialiError: string | undefined
    stato_abitazioneError: string | undefined
    
    abitazione_principaleError: string | undefined
    sede_lavoroError: string | undefined
    vincolato_belle_artiError: string | undefined
    
    assicurazione_incendioError: string | undefined
    assicurazione_furtoError: string | undefined
    valore_beniError: string | undefined

    materiali: any
    stati: any
}

export type HomePageState = HomeState & PageWithBuildingState

export const homePageInitialState : HomePageState = {
    ...buildingInitialState,
    ...{
        
        materiale: undefined,
        altri_materiali: undefined,
        stato_abitazione: undefined,
        
        abitazione_principale: undefined,
        sede_lavoro: undefined,
        vincolato_belle_arti: undefined,
        
        assicurazione_incendio: undefined,
        assicurazione_furto: undefined,
        valore_beni: undefined,

        materialeError: undefined,
        altri_materialiError: undefined,
        stato_abitazioneError: undefined,

        abitazione_principaleError: undefined,
        sede_lavoroError: undefined,
        vincolato_belle_artiError: undefined,

        assicurazione_incendioError: undefined,
        assicurazione_furtoError: undefined,
        valore_beniError: undefined,

        materiali: undefined,
        stati: undefined,
    }
}

export const homeUpdate = createAction<HomePageState>('home/update')

export const homeReducer = createReducer ( 
    homePageInitialState,
    (builder) => {
        builder.addCase(homeUpdate, (state, action) => {
            return action.payload as HomePageState
        })
    }
)

export type HomeRootState = ReturnType<typeof store.getState>
export type HomeDispatch = typeof store.dispatch